import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { GoogleAuthProvider } from 'firebase/auth';

export const firebaseConfig = {
    apiKey: 'AIzaSyDoGzk2aG_0fEyrY_Ar8M5WDjab5s2hzkI',
    authDomain: 'vivamos-la-cuenca.firebaseapp.com',
    projectId: 'vivamos-la-cuenca',
    storageBucket: 'vivamos-la-cuenca.appspot.com',
    messagingSenderId: '952922655602',
    appId: '1:952922655602:web:7866778a10ae9547772beb',
    measurementId: 'G-8GMFY5RCFP',
};

export const firebaseApp = initializeApp(firebaseConfig);

export const firestore = getFirestore(firebaseApp);

export const auth = getAuth(firebaseApp);

export const googleAuthProvider = new GoogleAuthProvider();
